import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  coord: null,
  country: { value: 'US', isDefault: true },
  language: { value: 'en', isDefault: true },
};

const locationSlice = createSlice({
  name: 'location',
  initialState,
  reducers: {
    setCountry(state, action) {
      state.country.value = action.payload;
      state.country.isDefault = false;
    },
    setLanguage(state, action) {
      state.language.value = action.payload;
      state.language.isDefault = false;
    },
  },
});

export const { setCountry, setLanguage } = locationSlice.actions;

export const selectHasCountry = (state) => !!state.location.country.value;

export const selectCountryAndLanguage = (state) => ({
  country: state.location.country.value,
  language: state.location.language.value,
  isCountryDefault: state.location.country.isDefault,
  isLanguageDefault: state.location.language.isDefault,
});

export default locationSlice.reducer;